import {createSlice} from '@reduxjs/toolkit';
import {IOneOrder} from '../../types'
import reducers from './reducers'
import extraReducers from './extraReducers'

export * from '../../thunk/mockups';

const MockupsSlice = createSlice({
    name: "mockups",
    initialState: {
        data: {},
        stats:{},
        status: null,
        error: null,
        queryParams: null,
        latestRequestId: null,
    },
    reducers,
    extraReducers
});
const {actions, reducer} = MockupsSlice;
export const {setMockups, clearFilters} = actions;
export {reducer};
